import type { KickPlayerCmdData } from '../../base/Game.js'
import { GamePlayer } from '../../base/GamePlayer.js'
import { ohFail, OhHellRulesMessage, ohSucceed } from '../state/state.js'
import type { OhHellResult, OhHellState } from '../state/state.js'
export function kickPlayer(
  state: OhHellState,
  kickData: KickPlayerCmdData,
): OhHellResult {
  if (!state.players || state.players.length < 2) {
    return ohFail(OhHellRulesMessage.CantKickLastPlayer)
  }
  const exitingUserId = kickData.kickedPlayerId
  const players = buildPlayersWithExitedPlayer(
    state,
    exitingUserId,
    kickData.kickReason,
  )
  const kickedState: OhHellState = {
    ...state,
    players,
  }
  return ohSucceed(kickedState, [])
}

const buildPlayersWithExitedPlayer = (
  state: OhHellState,
  exitingPlayerId: string,
  kickReason: string | null,
): GamePlayer[] => {
  const players = [...state.players]
  const exitingPlayerIndex = players.findIndex(
    (player) => player.userId === exitingPlayerId,
  )
  if (exitingPlayerIndex !== -1) {
    const exitedPlayer: GamePlayer = {
      ...players[exitingPlayerIndex],
      didExit: true,
      kickReason: kickReason || null,
    }
    players.splice(exitingPlayerIndex, 1, exitedPlayer)
  }
  return players
}
